import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signInWithEmailAndPassword } from 'firebase/auth';
import api from '../../lib/api';
import { auth } from '../../lib/firebase';

export interface LoginPayload {
  email: string;
  password: string;
}

export interface User {
  id: string;
  email: string;
  name?: string;
}

export interface LoginResponse {
  token: string;
  user: User;
}

export const useLogin = () => {
  const queryClient = useQueryClient();

  return useMutation<LoginResponse, any, LoginPayload>({
    mutationFn: async ({ email, password }) => {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const token = await userCredential.user.getIdToken();

      // await api.post(
      //   "/users/sync",
      //   {},
      //   { headers: { Authorization: `Bearer ${token}` } }
      // );

      const resp = await api.get('/users', {
        headers: { Authorization: `Bearer ${token}` },
      });

      const user = resp.data.user;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      return { token, user };
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['authUser'], data.user);
    },
  });
};
